<template>
 <div class="containerNcm">  
    <div class="painel2">
        <img src="/arqlef/arqlef2.svg" alt="" />        
    </div>
    <div id="conteudoNota">
        <p class="txtDadosG" style="text-align:left;">Dados Gerais</p>
        <div class="dadosGerais">
            <div style="width:58%"> 
                <label for="">Chave de Acesso</label><br>
                <input type="text" v-model="this.$store.state.chave" readonly>
            </div>
            <div style="width:18%">
                <label for="">Número</label><br>
                <input type="text" v-model="this.json.identificacao.numero" readonly>
            </div>
            <div style="width:18%">
                <label for="">Versão XML</label><br>
                <input type="text" v-model="this.json.versao" readonly>
            </div>
        </div>
        <div class="lista">
            <div v-for="(n,i) in nomesNfe" :key="i" :class="{colocar:i == colocar}" @click="colocarClass(i,n)">
                {{n}}
            </div>
        </div>
        <component :is="componente" :table="table"/>
        <div id="oka">
            <div style="padding: 10px; color:#009188;border: 1px solid #009188;border-radius: 5px;font-weight: 600;cursor:pointer;" @click="voltar()">
                Voltar
            </div>
            <div @click="print()" style="padding:10px;background: #009188;width:213px;color: #ffff;border-radius:5px;cursor:pointer;display:flex; justify-content: space-around;">
                <img src="/arqlef/impressora.svg" alt=""><span>IMPRIMIR ESTA ABA</span>
            </div>
        </div>
    </div>
 </div>
</template>

<script>
import config from '../services/config'
import tableEmitente from '../components/tableEmitente'
import tableDest from '../components/tableDest'
import tableNfe from '../components/tableNfe'
import tableProdutosServe from '../components/tableProdutosServe'
import tableTotais from '../components/tableTotais'
import tableTrans from '../components/tableTras'
import tableCobraca from '../components/tableCobraca'
import tableInfoPag from '../components/tableInfoPag'
export default {
    components:{tableNfe,tableEmitente,tableDest,tableProdutosServe,tableTotais,tableTrans,tableCobraca,tableInfoPag},
    data(){
        return{
            componente:'tableNfe',
            colocar:0,
            nomesNfe:['NFe','Emitente','Destinatário', 'Produtos e Serviços', 'Totais','Transporte', 'Cobrança','Informações Adicionais'],
            json:{},
            table:{},
            table_nfe:{                
                emissao_b:[
                    {
                        nome:'Natureza da Operação',
                        dado:'',
                        tamanho:'32'
                    },
                    {
                        nome:'Tipo da Operação',
                        dado:'',
                        tamanho:'32'
                    },
                    {
                        nome:'Digest Value da NF-e',
                        dado:'',
                        tamanho:'32'
                    },
                ],
                emissao:[
                     {
                        nome:'Processo',
                        dado:'',
                        tamanho:'41'
                    },
                    {
                        nome:'Versão do Processo',
                        dado:'',
                        tamanho:'20'
                    },
                    {
                        nome:'Tipo de Emissão',
                        dado:'',
                        tamanho:'20'
                    },
                    {
                        nome:'Finalidade',
                        dado:'',
                        tamanho:'14'
                    }
                ],
                destinatario:[
                     {
                        nome:'CNPJ',
                        dado:'',
                        tamanho:'27'
                    },
                    {
                        nome:'Nome / Razão Social',
                        dado:'',
                        tamanho:'35'
                    },
                    {
                        nome:'Inscrição Estadual',
                        dado:'',
                        tamanho:'27'
                    },
                    {
                        nome:'UF',
                        dado:'',
                        tamanho:'6'
                    }
                ],
                destinatario_b:[
                    {
                        nome:'Destino da Operação',
                        dado:'',
                        tamanho:'32'
                    },
                    {
                        nome:'Consumidor Final',
                        dado:'',
                        tamanho:'32'
                    },
                    {
                        nome:'Presença do Comprador',
                        dado:'',
                        tamanho:'32'
                    },
                ],
                situacao:[],
                dadosNfe:[
                    {
                        nome:'Modelo',
                        dado:'-',
                        tamanho:'7'
                    },
                    {
                        nome:'Série',
                        dado:'-',
                        tamanho:'7'
                    },
                    {
                        nome:'Número',
                        dado:'-',
                        tamanho:'11'
                    },
                    {
                        nome:'Data de Emissão',
                        dado:'-',
                        tamanho:'22'
                    },
                    {
                        nome:'Data/Hora de Saída ou da Entrada',
                        dado:'-',
                        tamanho:'22'
                    },
                    {
                        nome:'Valor Total da Nota Fiscal',
                        dado:'-',
                        tamanho:'24'
                    },
                ],
                emitente:[
                    {
                        nome:'CNPJ',
                        dado:'',
                        tamanho:'27'
                    },
                    {
                        nome:'Nome / Razão Social',
                        dado:'',
                        tamanho:'35'
                    },
                    {
                        nome:'Inscrição Estadual',
                        dado:'',
                        tamanho:'27'
                    },
                    {
                        nome:'UF',
                        dado:'',
                        tamanho:'6'
                    }
                ]
            },
            table_emit:{
                emitente_e:[
                    {
                        nome:'Nome / Razão Social',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'CNPJ',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'Bairro / Distrito',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'Munícipio',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'UF',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'Inscrição Estadual',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'Inscrição Municipal',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'CNAE Fiscal',
                        dado:'',
                        tamanho:'100'
                    },
                    
                ],
                emitente_d:[
                    {
                        nome:'Nome Fantasia',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'Endereço',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'CEP',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'Telefone',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'País',
                        dado:'',
                        tamanho:'100'
                    },
                     {
                        nome:'Inscrição Estadual do Substituto Tributário',
                        dado:'',
                        tamanho:'100'
                    },
                     {
                        nome:'Município da Ocorrência do Fato Gerador do ICMS',
                        dado:'',
                        tamanho:'100'
                    },
                     {
                        nome:'Código de Regime Tributário',
                        dado:'',
                        tamanho:'100'
                    },
                ]
            },
            table_dest:{
                localEntrega_d:[
                    {
                        nome:'Razão Social ou Nome do Recebedor',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'Endereço',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'Munícipio',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'Código do Pais',
                        dado:'',
                        tamanho:'100'
                    },
                     {
                        nome:'Telefone',
                        dado:'',
                        tamanho:'100'
                    },                   
                    {
                        nome:'Inscrição Estatual ou Estabelecimento Recebedor',
                        dado:'',
                        tamanho:'100'
                    },
                ],
                localEntrega_e:[
                    {
                        nome:'CNPJ',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'Bairro / Distrito',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'Munícipio',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'UF',
                        dado:'',
                        tamanho:'100'
                    },                    
                    {
                        nome:'Nome do Pais',
                        dado:'',
                        tamanho:'100'
                    },                   
                     {
                        nome:'Endereço de e-mail do Recebedor',
                        dado:'',
                        tamanho:'100'
                    },
                ],
                rz:{
                        nome:'Nome / Razão Social',
                        dado:'',
                        tamanho:'100'
                    },
                 dest_e:[                   
                    {
                        nome:'CNPJ',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'Bairro / Distrito',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'Munícipio',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'UF',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'Indicador IE',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'Inscrição Municipal',
                        dado:'',
                        tamanho:'100'
                    },                   
                     {
                        nome:'Inscrição Estadual',
                        dado:'',
                        tamanho:'100'
                    },
                    
                ],
                dest_d:[
                    {
                        nome:'E-mail',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'Endereço',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'CEP',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'Telefone',
                        dado:'',
                        tamanho:'100'
                    },
                     {
                        nome:'IM',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'País',
                        dado:'',
                        tamanho:'100'
                    },
                     {
                        nome:'Inscrição SUFRAMA',
                        dado:'',
                        tamanho:'100'
                    },
                     
                ]
            },
            table_prod_ser:{    
                prod_ser_e:[
                    {
                        nome:'Código do Produto',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'Indicador de Escala Relevante',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'Código EX da TIPI',
                        dado:'',
                        tamanho:'100'
                    }, 
                    {
                        nome:'Valor do Desconto',
                        dado:'',
                        tamanho:'100'
                    },
                ],
                prod_ser_m:[
                    {
                        nome:'Código NCM',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'CNPJ do Fabricante da Mercadoria',
                        dado:'',
                        tamanho:'100'
                    },
                    {
                        nome:'CFOP',
                        dado:'',
                        tamanho:'100'
                    }, 
                    {
                        nome:'Valor Total do Frete',
                        dado:'',
                        tamanho:'100'
                    },
                ]
            }

        }
    },
    methods:{
        print(){
           document.querySelector('.lista').style.display ="none"
window.print();
document.querySelector('.lista').style.display ="flex"
        },
        voltar(){
            this.$router.push({
                name:'notas'
                })
        },
        colocarClass(i,n){
             this.colocar = i             
            if(n== 'NFe'){
                console.log(this.table)
                this.table = this.table_nfe
                console.log(this.table)
                this.chamarTudoNfe(this.json)
                this.componente = 'tableNfe'
            }else if(n== 'Emitente'){
                this.table = this.table_emit
                this.abaEmitente(this.json)
                this.componente = 'tableEmitente'
            }else if(n =='Destinatário'){
                this.table = this.table_dest
                this.abaDest(this.json)
                this.componente = 'tableDest'
            }else if(n == 'Produtos e Serviços'){
                this.table = this.json.produtos                
                this.componente = 'tableProdutosServe'
            }else if(n == 'Totais'){     
                this.table = this.json.total          
                this.componente = 'tableTotais'
            }else if(n == 'Transporte'){
                this.table = this.json.transporte  
                 this.componente = 'tableTrans'
            }else if(n == 'Cobrança'){
                this.table = this.json.cobranca
                this.componente = 'tableCobraca'
            }else if(n == 'Informações Adicionais'){
                this.table = this.json.informacoesAdicionais
                console.log(this.json.informacoesAdicionais);
                this.componente = 'tableInfoPag'
            }
           
        },
        async getNfeCompleta(){
            let status = await config.getNfeCompleta(this.$store.state.idEmpresa,this.$store.state.chave)
            if(status.status <=204){ 
                this.table = this.table_nfe
                this.json = status.data
                this.chamarTudoNfe(status.data)
            }
        },         
        abaDest(json){
            this.table.rz.dado = json.destinatario.razaoSocial
            this.table.dest_e[0].dado = json.destinatario.documento
            this.table.dest_e[1].dado = json.destinatario.endereco.bairro
            this.table.dest_e[2].dado = json.destinatario.endereco.municipio
            this.table.dest_e[3].dado = json.destinatario.endereco.uf
            this.table.dest_e[4].dado = json.destinatario.indicadorIE
            this.table.dest_e[5].dado = json.destinatario.im
            this.table.dest_e[6].dado = json.destinatario.ie
            this.table.dest_d[0].dado = json.destinatario.email
            this.table.dest_d[1].dado = json.destinatario.endereco.logradouro
            this.table.dest_d[2].dado = json.destinatario.endereco.cep
            this.table.dest_d[3].dado = json.destinatario.endereco.telefone
            this.table.dest_d[4].dado = json.destinatario.endereco.im
            this.table.dest_d[5].dado = json.destinatario.endereco.pais
            this.table.dest_d[6].dado = json.destinatario.inscricaoSUFRAMA
            if(json.destinatario.localEntrega !=  null){
                this.table.localEntrega_e[0].dado =json.destinatario.localEntrega.documento
            this.table.localEntrega_e[1].dado =json.destinatario.localEntrega.bairro
            this.table.localEntrega_e[2].dado =json.destinatario.localEntrega.municipio
            this.table.localEntrega_e[3].dado =json.destinatario.localEntrega.uf
            this.table.localEntrega_e[4].dado =json.destinatario.localEntrega.pais
            this.table.localEntrega_e[5].dado =json.destinatario.localEntrega.logradouro
            }
            
           
        },
        abaEmitente(json){
            this.table.emitente_e[0].dado = json.emitente.razaoSocial
            this.table.emitente_e[1].dado = json.emitente.documento
            this.table.emitente_e[2].dado = json.emitente.endereco.bairro
            this.table.emitente_e[3].dado = json.emitente.endereco.municipio
            this.table.emitente_e[4].dado = json.emitente.endereco.uf
            this.table.emitente_e[5].dado = json.emitente.ie
           this.table.emitente_e[6].dado = json.emitente.im       
           
            this.table.emitente_e[7].dado = json.emitente.cnaeFiscal

            this.table.emitente_d[1].dado = json.emitente.endereco.logradouro
            this.table.emitente_d[2].dado = json.emitente.endereco.cep
            this.table.emitente_d[3].dado = json.emitente.endereco.telefone
            this.table.emitente_d[4].dado = json.emitente.endereco.pais
            this.table.emitente_d[5].dado = json.emitente.ieSubstitutoTributario
            this.table.emitente_d[6].dado = json.emitente.municipioOcorrencia
            this.table.emitente_d[7].dado = json.emitente.regimeTributario

        },
        chamarTudoNfe(json){            
            this.colocarNfe(json)
            this.colocarEmitente(json)
            this.colocarDestinatario(json)
            this.colocarEmissao(json)
            this.table.situacao = json.situacao
        },
        colocarNfe(json){
            this.table.dadosNfe[0].dado = json.identificacao.modelo
            this.table.dadosNfe[1].dado = json.identificacao.serie
            this.table.dadosNfe[2].dado = json.identificacao.numero
            this.table.dadosNfe[3].dado = json.identificacao.dataEmissao
            this.table.dadosNfe[4].dado = json.identificacao.dataSaidaEntrada
            this.table.dadosNfe[5].dado = json.total.icms.totalNFe
           
        },
        colocarEmitente(json){
            this.table.emitente[0].dado = json.emitente.documento
            this.table.emitente[1].dado = json.emitente.razaoSocial
            this.table.emitente[2].dado = json.emitente.ie
            this.table.emitente[3].dado = json.emitente.endereco.uf

          
        },
        colocarDestinatario(json){
            this.table.destinatario[0].dado = json.destinatario.documento
            this.table.destinatario[1].dado = json.destinatario.razaoSocial
            this.table.destinatario[2].dado = json.destinatario.ie
            this.table.destinatario[3].dado = json.destinatario.endereco.uf

            this.table.destinatario_b[0].dado = json.identificacao.destinoOp
            this.table.destinatario_b[1].dado = json.identificacao.consumidorFin
            this.table.destinatario_b[2].dado = json.identificacao.presensaCompra
        },    
        colocarEmissao(json){
            this.table.emissao[0].dado = json.emitente.documento
            this.table.emissao[1].dado = json.emitente.razaoSocial
            this.table.emissao[2].dado = json.emitente.ie
            this.table.emissao[3].dado = json.emitente.endereco.uf

            this.table.emissao_b[0].dado = json.emissao.naturezaOperacao
            this.table.emissao_b[1].dado = json.emissao.tipo
            this.table.emissao_b[2].dado = json.emissao.digestValue
        }  
    },
    created(){
        this.getNfeCompleta()
    }

}
</script>

<style>
#oka{
    display:flex;justify-content:space-between;align-items:center;margin:20px 0px;
}
@media print {
.rodape,.painel2,.dadosGerais,#navba,div.lista,div#oka {display:none};
 div.conteudoTable{
     height: 100vh;
     width: 100%;
 }
 #conteudoNota input, textarea{
     font-size: 18  !important;
 }

}
.cortar{
    display:flex; width:100%; justify-content: space-between;
}            
#conteudoNota .conteudoTable{
    border:3px solid #06938A;
    min-height: 370px;
    padding:12px;    
    position: relative;
    top: -3px;
}
#conteudoNota  input,textarea{
    border-radius: 5px;
    border: 1px solid #06938A;
    font-size: 14px;
    padding:2.5px 10px;
    width: 100%;
}
#conteudoNota  .lista{
    display: flex;
    margin-top:60px;
}
#conteudoNota  .lista div.colocar{
    position: relative;
    top: 0px;
    z-index: 2;
    background: #fff;
     border-top: 3px solid #06938A;
     border-left: 3px solid #06938A;
     border-right: 3px solid #06938A;
}
#conteudoNota  .lista div{
    display: flex;
    padding: 12px 18px;
    border: 1px solid #009188;
    cursor: pointer;
    margin-left: 0.1px;
    border-radius: 8px 8px 0px 0px;
    border-bottom: 0px;    
    font-size: 15px;
    color:#009188;
}
#conteudoNota label{
    color:#009188;
    font-size: 14px;
}
#conteudoNota .dadosGerais{
    width: 100%;
    border: 2px solid #06938A;
    background: #06938A1A;
    display: flex;
    text-align: left;
    border-radius: 5px;
    justify-content: space-between;
    padding:10px 10px;
}

#conteudoNota .dadosGerais label{
    margin-bottom: .1rem;    
}
#conteudoNota{
    padding:10px;
    padding-top: 25px;
}
.txtDadosG{
    color: #06938A;
    font-weight: bold;
    font-size: 16px;    
    margin-top:30px;
}
</style>